// FACEIT level icon + ELO, linking to the player's FACEIT profile when one can be built.
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function FaceitBadge({ faceit }) {
  const { t } = useTranslation();
  if (!faceit) return null;
  const hasLevel = faceit.skill_level !== null && faceit.skill_level !== undefined;
  const hasElo = faceit.faceit_elo !== null && faceit.faceit_elo !== undefined;
  if (!hasLevel && !hasElo) return null;

  const level = hasLevel ? faceit.skill_level : '?';
  const levelNumber = Number(level);
  const iconLevel = Number.isInteger(levelNumber) && levelNumber >= 1 && levelNumber <= 10 ? levelNumber : null;
  const elo = hasElo ? Math.round(Number(faceit.faceit_elo)) : null;

  // Prefer the permanent UUID link (survives a rename), then the nickname path, then faceit_url.
  const profileUrl = faceit.player_id
    ? `https://www.faceit.com/users/${faceit.player_id}`
    : (faceit.nickname
      ? `https://www.faceit.com/en/players/${encodeURIComponent(faceit.nickname)}`
      : (faceit.faceit_url ? faceit.faceit_url.replace('{lang}', 'en') : null));

  const title = elo !== null
    ? t('teams.faceitTitleElo', 'FACEIT {{nick}} - level {{level}}, {{elo}} ELO', { nick: faceit.nickname || '', level, elo })
    : t('teams.faceitTitle', 'FACEIT {{nick}} - level {{level}}', { nick: faceit.nickname || '', level });

  const inner = (
    <>
      {iconLevel
        ? <img src={`/faceit-levels/skill_level_${iconLevel}.png`} alt={t('teams.faceitLevel', 'FACEIT level {{level}}', { level: iconLevel })} />
        : <span>F{level}</span>}
      {elo !== null && <span className="elo">{elo}</span>}
    </>
  );
  if (!profileUrl) return <span title={title} className="tm-faceit">{inner}</span>;
  return <a href={profileUrl} target="_blank" rel="noopener noreferrer" title={title} onClick={e => e.stopPropagation()} className="tm-faceit">{inner}</a>;
}
